import React, { useState, useEffect } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

const Footer = () => {
  const [versionInfo, setVersionInfo] = useState(null);

  useEffect(() => {
    // Load version info from public/version.json (generated at build time)
    fetch('/version.json')
      .then(res => res.json())
      .then(data => setVersionInfo(data))
      .catch(err => {

        setVersionInfo({
          version: 'dev',
          commit: 'unknown',
          branch: 'main',
          date: new Date().toISOString(),
          message: 'Development build'
        });
      });
  }, []);

  if (!versionInfo) return null;

  const tooltipContent = (
    <Box>
      <Typography variant="caption" display="block"><strong>Commit:</strong> {versionInfo.commit}</Typography>
      <Typography variant="caption" display="block"><strong>Branch:</strong> {versionInfo.branch}</Typography>
      <Typography variant="caption" display="block"><strong>Date:</strong> {versionInfo.date}</Typography>
      <Typography variant="caption" display="block"><strong>Message:</strong> {versionInfo.message}</Typography>
      {versionInfo.buildDate && (
        <Typography variant="caption" display="block"><strong>Built:</strong> {new Date(versionInfo.buildDate).toLocaleString()}</Typography>
      )}
    </Box>
  );

  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '32px',
        background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        zIndex: 1200,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        fontSize: '0.75rem'
      }}
    >
      <Typography variant="caption" sx={{ color: 'inherit', fontWeight: 600 }}>
        Learning Architect © {new Date().getFullYear()}
      </Typography>
      
      <Tooltip title={tooltipContent} arrow placement="top">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.9
            }
          }}
        >
          <InfoIcon sx={{ fontSize: 14 }} />
          <Typography variant="caption" sx={{ color: 'inherit', fontWeight: 500 }}>
            Version {versionInfo.version}
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default Footer;

